var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_40141",
    "data-name": "Group 40141",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path_82670",
    "data-name": "Path 82670",
    fill: "#fff",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23.5 23.5 L 0.5 23.5 L 0.5 0.5 L 23.5 0.5 L 23.5 23.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1 1 L 1 23 L 23 23 L 23 1 L 1 1 M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 Z",
    stroke: "none",
    fill: "#707070"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-mail",
    "data-name": "Icon feather-mail",
    transform: "translate(2 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82668",
    "data-name": "Path 82668",
    d: "M4.919,6h15.35a1.924,1.924,0,0,1,1.919,1.919V19.431a1.924,1.924,0,0,1-1.919,1.919H4.919A1.924,1.924,0,0,1,3,19.431V7.919A1.924,1.924,0,0,1,4.919,6Z",
    transform: "translate(-3 -6)",
    fill: "none",
    stroke: "#878a99",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82669",
    "data-name": "Path 82669",
    d: "M22.188,9l-9.594,6.716L3,9",
    transform: "translate(-3 -7.081)",
    fill: "none",
    stroke: "#878a99",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.059208f692921bb203aa5f7f46ad0e22.svg";
export { ForwardRef as ReactComponent };